import * as React from 'react'
import Image from '@components/Image'
import { getLayoutConfig } from '../config'

export const Logo = () => {
  const config = getLayoutConfig()

  return <Image alt={config.copyright} height={132} src={config.logo} width={64} />
}
